<template>
  <div class="archi">
    <div class="Company_box">
      <p class="Company_text">组织架构</p>
      <div class="arrow-right" style="margin-top:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>企业概况</el-breadcrumb-item>
          <el-breadcrumb-item>组织架构</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="Organization">
      <img :src="url+organization[0].image" alt />
    </div>
  </div>
</template>
<script>
import axios from 'axios'  //注入
import qs from 'qs'     //注入
export default {
  data() {
    return {
      cur: 1,
      organization: [],
      url:this.$axios.defaults.baseURL,
    };
  },
  created() {
    this.OrganizationChart()
  },
  methods: {
    OrganizationChart: function () {
      this.$axios({
        // method: "post",
        // data: qs.stringify({
        //   //           id:id,
        // }),
        // url: "/index.php/news/news3",
        method: "get",
        url: "/changhang/index/list?menu=2&type=13",
        // header: {
        //   "Content-Type": "application/x-www-form-urlencoded", //post请求设置
        // },
      }).then((res) => {
        this.organization = res.data.rows
        console.log(res, "qqqqqqqqqqqqqq");
      })
    }
  },
};
</script>
<style scoped>
.aaa {
  width: 100px;
  height: 100px;
  background: chartreuse;
  /* 1 */
}

.enterprise_name {
  font-size: 1.5vw;
  color: #0c47a1;
  text-align: center;
  margin-top: 1vw;
}

.Organization {
  /* width: 50%; */
  margin: 0 auto;
  /* margin-top: 20px; */
}

.Organization img {
  width: 100%;
  height: 100%;
  margin-bottom: 5%;

}

.archi {
  margin-top: -2%;
  margin-left: 40px;
}

.archi .el-breadcrumb {
  line-height: 1.5 !important;
  font-size: 0.9vw !important;
}

.Company_box {
  width: 100%;
  /* height: 7vh !important; */
  height: 64px !important;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dedede;
  /* height: 3.3vw !important; */
}

.Company_text {
  font-size: 32px;
  color: #0c47a1;
  text-align: center;
  line-height: 2;
}

/* .arrow-right {
  text-align: center;
  margin-top: 1vw;
} */
@media screen and (min-width: 320px) and (max-width: 750px) {
  .archi {
    margin-left: -5%;
  }

  .Company_box {
    display: none;
  }

  .archi .Company_text {
    display: none;
  }

  .archi .arrow-right .el-breadcrumb {
    padding-left: 3%;
    margin-top: -3%;
    font-size: 12px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Architecture.vue